export interface AssetReportType {
    label: string;
    countField: string;
    datasourceId: string;
    filterKey: string;
}

export const ASSET_KEY_FIELD = "AEIC";

export const ASSET_REPORT_TYPES: AssetReportType[] = [
    {
        label: "Exception Reports",
        countField: "ExceptionReportCount",
        datasourceId: "pdc_reports",
        filterKey: ASSET_KEY_FIELD,
    },
    {
        label: "Failed Sensor Reports",
        countField: "FailedSensorReportCount",
        datasourceId: "pdc_failed_sensor_reports",
        filterKey: ASSET_KEY_FIELD,
    },
    {
        label: "Field Service Reports",
        countField: "FieldServiceReportCount",
        datasourceId: "field_service_reports",
        filterKey: ASSET_KEY_FIELD,
    },
];
